/**
 * @prop --backdrop-opacity: Opacity of overlay backdrop
 * @prop --backdrop-background-color: Background color of overlay backdrop
 *
 * @prop --stzh-overlay-backdrop-opacity: **Global**: Opacity of backdrops
 * @prop --stzh-overlay-backdrop-background-color: **Global**: Background color of backdrops
 */

:host {
  --backdrop-opacity: #{$overlayBackdropOpacity};
  --backdrop-background-color: #{$overlayBackdropBackgroundColor};
}

.stzh-overlay {
  display: none;
  z-index: $zIndexOverlay;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;

  &__backdrop {
    z-index: 1;
    background-color: var(--backdrop-background-color);
    opacity: var(--backdrop-opacity);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__content {
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex-grow: 1;
    overflow: auto;
  }

  &__content-inner {
    // center content vertically
    margin-top: auto;
    margin-bottom: auto;
    outline: none;
  }

  &--is-open {
    display: flex;
  }
}
